export default __webpack_public_path__ + "static/media/0x709a4b6217584188ddb93c82f5d716d969acce1c.9eb1c508.webp";